<template>
  <div class="myDialog" v-if="showDialog">
    <detailStyle class="logContent" id="logContent" :style="{height:logHeight}" :title="logTitle">
      <div class="logMain">
        <slot/>
      </div>
    </detailStyle>
  </div>
</template>

<script>
import detailStyle from '@/views/accident/components/detailStyle.vue'
export default {
  components: { detailStyle },
  props: {
    logTitle: {
      type: String,
      default: () => "弹窗信息"
    },
    logHeight:{
      type: String,
      default:() =>'600px'
    },
    showDialog: {
      type: Boolean,
      default:() => false
    },
    docHidden: {
      type: Boolean,
      default:() => false
    },
  },
  mounted() {
    // 点击空白处隐藏弹窗
    if (this.docHidden) {
      document.addEventListener('mouseup',(e) =>{
        let self = document.getElementById('logContent')
        if(self && !self.contains(e.target)) {
          this.$emit('update:showDialog',false);
        }
      })
    }
    
  }
}
</script>

<style lang="scss">
  .myDialog {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 99999;
    &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        background-color:  rgba(0, 0, 0, 0.11);
        backdrop-filter: blur(5px);
        z-index: -1;
        /* 重要 */
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
    }
    .logContent {
      width: 800px;
      max-height: 600px;
      padding: 55px 40px;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      background: #0F1F46;
      &::-webkit-scrollbar {
        /*定义滚动条高宽及背景
        高宽分别对应横竖滚动条的尺寸*/
        width: 6px;
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        display: block;
        width: 6px;
        margin: 0 auto;
        border-radius: 10px;
        background: #eee;
      }
      .logMain {
        max-height: 340px;
        overflow-y: auto;
      }
    }
  }
</style>>